export default __webpack_public_path__ + "static/media/GlennImage.be268d3a.png";